// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

// ** UseJWT import to get config
import useJwt from "@src/auth/jwt/useJwt";

// ** Axios Imports
import axios from "@configs/axios";

// ** Sentry Imports
import { setSentryUser, clearSentryUser } from "@configs/sentry";

const config = useJwt.jwtConfig;

const initialUser = () => {
  const item = localStorage.getItem("userData");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const forgetPassword = async (mobile, lang) => {
  const data = { mobile };
  return axios
    .post("/forgotPassword", data, {
      headers: {
        "x-lang": `${lang}`, // Replace 'your-lang-value' with the actual value you want to send
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return {
        data: {},
      };
    });
};

export const updatePassword = async (
  mobile,
  activationCode = "",
  password = "",
  lang
) => {
  const data = { mobile, activation_code: activationCode, password };
  return axios
    .post("/forgotPassword", data, {
      headers: {
        "x-lang": `${lang}`, // Replace 'your-lang-value' with the actual value you want to send
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      return {
        data: {},
      };
    });
};

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    userData: initialUser(),
    userRegister: {},
    userStepTwoLogin: {},
  },
  reducers: {
    handleUserRegister: (state, action) => {
      state.userRegister = action.payload;
    },
    handleUserTwoStepLogin: (state, action) => {
      state.userStepTwoLogin = action.payload;
    },
    handleLogin: (state, action) => {
      if (action.payload.first_name !== null && action.payload.last_name !== null) {
        action.payload.username = `${action.payload.first_name} ${action.payload.last_name}`;
      } else action.payload.username = "کاربر";
      action.payload.role = "کاربر";
      state.userData = action.payload;
      state[config.storageTokenKeyName] = action.payload[config.storageTokenKeyName];
      state[config.storageRefreshTokenKeyName] =
        action.payload[config.storageRefreshTokenKeyName];
      localStorage.setItem("userData", JSON.stringify(action.payload));
      localStorage.setItem(config.storageTokenKeyName, action.payload.accessToken);

      // ✅ FIX #1: Store refresh token as plain string (not JSON.stringify)
      // Note: Based on backend API docs, this system uses the access token itself for refresh
      // The refresh token field may not exist, so we only store if it's provided
      if (action.payload.refreshToken) {
        localStorage.setItem(
          config.storageRefreshTokenKeyName,
          action.payload.refreshToken  // Store as plain string, not JSON.stringify
        );
      }

      // Set Sentry user context for error tracking
      setSentryUser(action.payload);

      // ✅ FIX #2: Dispatch custom event to notify WebSocketService about login
      // The 'storage' event only fires in other tabs, not the current tab
      // So we need to manually dispatch a custom event for same-tab login detection
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('userLoggedIn', {
          detail: { userData: action.payload }
        }));
      }
    },
    handleLogout: (state) => {
      state.userData = {};
      state[config.storageTokenKeyName] = null;
      state[config.storageRefreshTokenKeyName] = null;
      document.cookie.split(";").forEach((cookie) => {
        const cookieName = cookie.split("=")[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
      });
      localStorage.setItem("showInstallModalStep", 3);
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("fetchUser");
      localStorage.removeItem("reactQueryDevtoolsSortFn");
      localStorage.removeItem("userData");
      localStorage.removeItem("accessToken");
      // localStorage.removeItem("coins");
      // sessionStorage.clear();

      // Clear Sentry user context
      clearSentryUser();

      window.location.href = "/login";
    },
  },
});

export const { handleLogin, handleLogout, handleUserRegister, handleUserTwoStepLogin } =
  authSlice.actions;

export default authSlice.reducer;
